export default __webpack_public_path__ + "img/WB_RT_NOMA_WF.a1e33166c04a83165fe71fea303857a6.jpg";